import {
  VALIDATE_USER_CREDENTIAL,
  VALIDATION_FAILURE
} from "../reducerConstants";

const initialState = () => {
  return {
    subscribed: localStorage.getItem("user") ? true : false,
    data:{},
    error:'',
  };
};

const userReducer = (state = initialState(), action = {}) => {
  let errorMessage = action.error && action.error.data && action.error.data.Error;
  switch (action.type) {
    case VALIDATE_USER_CREDENTIAL:
      return {
          ...state,
          data : action.data,
          error:'',
      };
    case VALIDATION_FAILURE:
      return {
          ...state,
          data: [],
          error: errorMessage
      };
    default:
      return state;
  }
};

export default userReducer;
